import { lazy, Suspense, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const Viewer = lazy(() => import("./PhotoLightbox").then(module => ({ default: module.PhotoLightbox })));

const LoadingViewer = ({ onClose }) => {
  const { t } = useLanguage();
  useEffect(() => {
    const close = event => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [onClose]);
  return createPortal(<div data-testid="lightbox-loading" className="fixed inset-0 z-[200] bg-[#08121d]/95 flex items-center justify-center text-white">
    <div role="status" className="flex items-center gap-3 text-sm"><span className="w-5 h-5 rounded-full border-2 border-white/30 border-t-white motion-safe:animate-spin" aria-hidden="true" />Shylov Cleaning</div>
    <button type="button" data-testid="lightbox-loading-close" aria-label={t("studio.close")} onClick={onClose} className="absolute top-6 right-6 lightbox-control"><X size={20} /></button>
  </div>, document.body);
};

export const PhotoLightbox = props => {
  const [hasOpened, setHasOpened] = useState(false);
  useEffect(() => { if (props.index !== null) setHasOpened(true); }, [props.index]);
  if (!hasOpened && props.index === null) return null;
  return <Suspense fallback={props.index === null ? null : <LoadingViewer onClose={props.onClose} />}><Viewer {...props} /></Suspense>;
};